"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EMPTY_DEPENDENCIES_TOKEN = exports.generateDependenciesToken = void 0;
var isPlainObject_1 = __importDefault(require("lodash/isPlainObject"));
var hashString_1 = require("./src/hashString");
var generateDependenciesToken = function (dependencies) {
    if (!isPlainObject_1.default(dependencies)) {
        throw new Error("dependencies must be an object");
    }
    var sortedImportNames = Object.keys(dependencies).sort();
    var sortedDependencies = sortedImportNames.reduce(function (acc, importName) {
        var _a;
        return (__assign(__assign({}, acc), (_a = {}, _a[importName] = dependencies[importName], _a)));
    }, {});
    return hashString_1.hashString(JSON.stringify(sortedDependencies));
};
exports.generateDependenciesToken = generateDependenciesToken;
var EMPTY_DEPENDENCIES_TOKEN = generateDependenciesToken({});
exports.EMPTY_DEPENDENCIES_TOKEN = EMPTY_DEPENDENCIES_TOKEN;
//# sourceMappingURL=index.js.map